import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { callAPI } from "../../../axios";
import { getChainIdLS, isAutoModeViewerUser } from "../../../utils/utils";
import HotelConfigList from "./HotelConfigList";
import { useNavigate } from "react-router-dom";
import RoomConfigList from "./RoomConfigList";
import BgConfigList from "./BgConfigList";
import ScreenSaverConfigList from "./ScreenSaverConfigList";
import RailConfigList from "./RailConfigList";
// import WelcomeMessageConfigList from "./WelcomeMessageConfigList";
import CustomizeWelcomeScreenList from "./CustomizeWelcomeScreenList";
import { CircularProgress } from "@mui/material";
import HotelAPK from "./HotelAPK";
// import GroupRoomsList from "./GroupRoomsList";

const FetchCdsnDetails = () => {
    const navigate = useNavigate();
    const [response, setResponse] = useState({});
    const [fetchCDSNHotelConfigList, setFetchCDSNHotelConfigList] = useState(null);
    const [fetchCDSNRoomConfigList, setFetchCDSNRoomConfigList] = useState(null);
    const [fetchCDSNBgConfigList, setFetchCDSNBgConfigList] = useState(null);
    const [fetchCDSNSsConfigList, setFetchCDSNSsConfigList] = useState(null);
    const [fetchCDSNRailConfigList, setFetchCDSNRailConfigList] = useState(null);
    const [welcomeMsgConfigList, setWelcomeMsgConfigList] = useState(null);
    const [customizeWelcomeConfigList, setCustomizeWelcomeConfigList] = useState(null);
    const [hotelAPKList, setHotelAPKList] = useState(null);
    // const [groupRoomList, setGroupRoomList] = useState(null);
    const allNullCdsn = Object.values(response).every(value => value === null);
    const [loader, setLoader] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: 'onChange'
    });

    useEffect(() => {
        if (isAutoModeViewerUser()) {
            navigate("/hms/APKInstallationDetails", { replace: true });
        }
    }, [navigate]);

    const onSubmit = (data) => {
        setLoader(true);
        callAPI(`/all-config?cdsn=${data?.cdsn}`, "GET", { cdsn: '' }, { chainId: getChainIdLS() })
            .then(function (response) {
                setResponse(response);
                setFetchCDSNHotelConfigList(response?.hotedetail);
                setFetchCDSNRoomConfigList(response?.roomConfig);

                setFetchCDSNSsConfigList(response?.scConfig);
                setFetchCDSNRailConfigList(response?.railConfig);
                setWelcomeMsgConfigList(response?.welcomeMessage);
                setCustomizeWelcomeConfigList(response?.customizedScreen);
                setHotelAPKList(response?.hotelApkCdsnResponse);
                if (response?.bgConfig !== null) {
                    setFetchCDSNBgConfigList(response?.bgConfig);
                } else if (response?.defaultBgImageResponse !== null) {
                    setFetchCDSNBgConfigList(response?.defaultBgImageResponse);
                }
                // setGroupRoomList(response?.groupRoomConfig);
                setLoader(false);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    };

    return (
        <div className='row config-hotel'>
            {loader && <div className="circular-progress"><CircularProgress /></div>}
            <div className='col-12 left-column'>
                <form autoComplete="off" className="hotel-list-form border-bottom-0" onSubmit={handleSubmit(onSubmit)}>
                    <p className="cdsn-details">Fetch CDSN Level Configurations</p>
                    <div className="d-flex">
                        {/* <div className="col-6 form-group-hotel mb-0">
                            <div className="floating-select-label">
                                <Controller
                                    name="cdsn"
                                    control={control}
                                    rules={{
                                        validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select CDSN',
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            className={`multiselectlist ${field?.value?.cdsn && field?.value?.cdsn.length > 0 ? 'Mui-focused' : ''}`}
                                            disablePortal
                                            options={cdsnsMaster}
                                            getOptionLabel={(option) => option?.cdsn?.toString()}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                            }}
                                            value={field?.value || null}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder=""
                                                    variant="outlined"
                                                    label="Select CDSN"
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                            </div>
                            {errors.cdsn && (
                                <small className="required">{errors.cdsn?.message}</small>
                            )}
                        </div> */}
                        <div className="form-group-hotel col-6 mb-0">
                            <div className="floating-label">
                                <input
                                    id="cdsn"
                                    maxLength={10}
                                    placeholder=""
                                    {...register("cdsn", {
                                        required: "Please Enter CDSN",
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message: "Only Numeric characters are allowed",
                                        },
                                    })}
                                />
                                <label htmlFor="address">Enter CDSN</label>
                            </div>
                            {errors.cdsn && (
                                <small className="required">{errors.cdsn.message}</small>
                            )}
                        </div>
                        <button type="submit" className={`create-btn ms-3 ${errors?.cdsn ? 'mb-4' : 'mb-0'}`}>Search</button>
                    </div>
                </form>

                {Object.keys(response).length !== 0 && <>{!allNullCdsn ? <>
                    {fetchCDSNHotelConfigList !== null && (
                        <HotelConfigList fetchCDSNHotelConfigList={fetchCDSNHotelConfigList} />
                    )}
                    {fetchCDSNRoomConfigList !== null && (
                        <RoomConfigList fetchCDSNRoomConfigList={fetchCDSNRoomConfigList} />
                    )}
                    {fetchCDSNRailConfigList !== null && (
                        <RailConfigList fetchCDSNHotelConfigList={fetchCDSNHotelConfigList} fetchCDSNRailConfigList={fetchCDSNRailConfigList} welcomeMsgConfigList={welcomeMsgConfigList} />
                    )}
                    {fetchCDSNBgConfigList !== null && (
                        <BgConfigList fetchCDSNBgConfigList={fetchCDSNBgConfigList} />
                    )}
                    {fetchCDSNSsConfigList !== null && (
                        <ScreenSaverConfigList fetchCDSNSsConfigList={fetchCDSNSsConfigList} />
                    )}
                    {/* {welcomeMsgConfigList !== null && (
                        <WelcomeMessageConfigList welcomeMsgConfigList={welcomeMsgConfigList} />
                    )} */}
                    {customizeWelcomeConfigList !== null && (
                        <CustomizeWelcomeScreenList customizeWelcomeConfigList={customizeWelcomeConfigList} />
                    )}
                    {hotelAPKList !== null && (
                        <HotelAPK hotelAPKList={hotelAPKList} />
                    )}
                    {/* {groupRoomList !== null  && (
                        <GroupRoomsList groupRoomList={groupRoomList} />
                    )} */}
                </> : <div className="cdsn-details-not-found">
                    <img src="/Images/no-data-icon.png" alt="no data found" />
                    <p>No Data found!</p>
                </div>
                }</>
                }
            </div>
        </div>
    )
}

export default FetchCdsnDetails